// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ecBb","footer":"Form_footer__3_-ze"};